var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgImage6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,0 C14.6568542,0 16,1.34314575 16,3 L16,13 C16,14.6568542 14.6568542,16 13,16 L3,16 C1.34314575,16 0,14.6568542 0,13 L0,3 C0,1.34314575 1.34314575,0 3,0 L13,0 Z M13,1.5 L3,1.5 C2.22030388,1.5 1.57955132,2.09488808 1.50686658,2.85553999 L1.5,3 L1.5,13 C1.5,13.7796961 2.09488808,14.4204487 2.85553999,14.4931334 L3,14.5 L13,14.5 C13.7796961,14.5 14.4204487,13.9051119 14.4931334,13.14446 L14.5,13 L14.5,3 C14.5,2.22030388 13.9051119,1.57955132 13.14446,1.50686658 L13,1.5 Z",
    id: "rounded-square",
    fill: "#374957",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgImage6);
export default __webpack_public_path__ + "static/media/svg-image-6.238560632cd561b3dc01666f17d9c08a.svg";
export { ForwardRef as ReactComponent };